import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Atributos',
            tblTitle: 'Lista de atributos',
            tblbutton: 'Nuevo atributo',
            mdlSave: 'Aceptar',
            mdlCancel: 'Cancelar',
            mdltext1: 'Atributo',
            mdltext2: 'Descripción',
            lblName: 'Nombre',
            lblDescription: 'Descripción',
            lblMinValue: 'Valor minimo',
            lblmMxValue: 'Valor maximo',
            lblEdit: 'Editar atributo',
            lblDelete: 'Eliminar atributo',
            dlgDeleteMapTitle: 'Eliminar atributo',
            dlgUploadTitle: 'Actualizar atributo',
            helpTitle: 'Sección de ayuda',
            helpText: 'Para poder asociar un atributo a una sala, primero es necesario crear dicho atributo y definir el tipo de atributo.Los atributos están clasificados en 3 tipos:',
            helpList1: 'Atributos TIENE/NO TIENE, es decir son aquellos atributos que únicamente se asocian a una sala para determinar si ésta cuenta con dicho atributo. Por ejemplo CLICKSHARE, EXT. TELÉFONICA, PROYECTOR, ETC.',
            helpList2: 'Atributos de CANTIDAD, aquellos atributos que permiten definir un valor NUMÉRICO asociado a la sala. Como por ejemplo CAPACIDAD.',
            helpList3: 'Atributos de DESCRIPCIÓN, aquellos atributos que permiten definir un valor de TEXTO asociado a la sala. Como por ejemplo PISO, cuyos valores pueden ser LOBBY, PLANTA BAJA, PRIMER PISO, etc.',

            headerSearch: 'Buscar',
            headerName: 'Nombre',
            headerDescription: 'Descripción',
            headerMinVal: 'Valor mínimo',
            headerMaxVal: 'Valor máximo',
            headerAction: 'Acciones',

            lblAttribute: 'Tipo de atributo',


            lbldelete1: 'Estás apunto de eliminar el atributo',
            lbldelete2: 'Estas Seguro?',

        },
        en: {
            moduleTitle: 'Attributes',
            tblTitle: 'Attributes List',
            tblbutton: 'New Attributes',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            mdltext1: 'Attributes',
            mdltext2: 'Description',
            lblName: 'Name',
            lblDescription: 'Description',
            lblMinValue: 'Min value',
            lblmMxValue: 'Max value',
            lblEdit: 'Edit attribute',
            lblDelete: 'Delete attribute',
            dlgDeleteMapTitle: 'Delete attributes',
            dlgUploadTitle: 'Upload attributes',
            helpTitle: 'Help section',
            helpText: 'In order to associate an attribute to a meeting room, it is first necessary to create that attribute and define the type of attribute. Attributes are classified into 3 types:',
            helpList1: "It HAS / DOESN'T have attributes, that is, those attributes that are only associated with a room to determine if it has this attribute. For example CLICKSHARE, EXT. TELEPHONE, PROJECTOR, ETC.",
            helpList2: 'QUANTITY attributes, those attributes that allow defining a NUMERIC value associated with the room. For example CAPACITY.',
            helpList3: 'DESCRIPTION attributes, those attributes that allow defining a TEXT value associated with the room. For example, FLAT, whose values can be LOBBY, GROUND FLOOR, FIRST FLOOR, etc.',

            headerName: 'Name',
            headerDescription: 'Description',
            headerMinVal: 'Minimum value',
            headerMaxVal: 'Maximum value',
            headerAction: 'Actions',
            headerSearch: 'Search',
            lblAttribute: 'Attribute type',


            lbldelete1: 'You are about to remove the attribute',
            lbldelete2: 'Are you sure?',

        }
    }
}

export default _.merge(messages, defaultMessages)